<template>
  <div class="f360-select" :class="{ 'f360-select--full': full }">
    <p
      class="f360-select__label"
      :class="{ 'f360-select__label--full': full }"
      v-if="label"
    >
      {{ label }}
    </p>
    <el-select
      v-bind="$attrs"
      class="f360-select__wrapper"
      :loading="loading"
      :class="{
        'f360-select__wrapper--full': full,
        'f360-select__wrapper--error': shouldShowError
      }"
      placement="bottom"
      :reserve-keyword="reserveKeyword"
      @focus="handleFocus"
      @blur="handleBlur"
    >
      <slot name="default" />
      <template #prefix v-if="$slots.prefix">
        <slot name="prefix" />
      </template>
    </el-select>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";

const props = withDefaults(
  defineProps<{
    label?: string;
    error?: boolean | string;
    full?: boolean;
    width?: string;
    reserveKeyword?: boolean;
    loading?: boolean;
  }>(),
  {
    width: "auto",
    reserveKeyword: false
  }
);

const isFocused = ref(false);

const handleFocus = () => {
  isFocused.value = true;
};

const handleBlur = () => {
  isFocused.value = false;
};

const shouldShowError = computed(() => {
  return props.error && !isFocused.value;
});
</script>

<style lang="scss">
@use "@/ui/styles/variables.scss" as *;
@use "@/ui/styles/theme/f360-theme.scss" as *;

@mixin select-error() {
  border: 1px solid #ed1517 !important;

  &:hover {
    background-color: #fff1f1;
  }
}

.f360-select {
  width: v-bind(width);

  &--full {
    width: 100%;
  }

  &__label {
    font-family: $fontFamily;
    color: $font-color;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    margin: 0 0 8px;
    text-wrap: nowrap;
  }

  &__wrapper {
    background-color: #fff;
    box-shadow: 0 0 0 1px $input-border inset;
    border-radius: 5px;
    box-sizing: border-box;

    .financas-select {
      &__input {
        font-family: $fontFamily !important;
        font-size: 12px;
        line-height: 16px;
      }

      &__wrapper {
        border-radius: 5px !important;
        border: none !important;
        box-shadow: none;
        background-color: transparent;

        &:focus {
          border: 1px solid $input-border-active;
        }
      }

      &__selection {
        font-family: "Plus Jakarta Sans", sans-serif !important;
        font-size: 12px;
        line-height: 16px;
      }
    }

    &:hover {
      background-color: #edf7ff;
    }

    &--full {
      width: 100%;
    }

    &--error {
      .financas-select.is-focus .financas-select__wrapper {
        @include select-error;
      }

      .financas-select__wrapper {
        @include select-error;

        &:hover {
          @include select-error;
        }

        &:focus,
        &:active {
          @include select-error;
        }
      }

      .financas-icon {
        color: red !important;

        .financas-select__inner {
          font-family: $fontFamily !important;
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
